import * as React from "react";
import { Button } from "components/controls/widget";


interface RegistraceNovehoParuProps {
    paryRootPath: string;
}

class RegistraceNovehoParu extends React.PureComponent<RegistraceNovehoParuProps>{

    render() {
        const { paryRootPath } = this.props;
        const link = paryRootPath + '/registrace/';
        //        return <a href={link}>{'Detail'}</a>; //  <Link to={link}>Detail</Link>;

        return <Button color="primary" variant="outlined" href={link}>{'Registrace nového páru'}</Button>
    }
}

export default RegistraceNovehoParu;